export default __webpack_public_path__ + "static/media/osrcr02_2.270b0396.png";